import React from 'react';
import { FormattedMessage } from 'react-intl';

const Disclaimer = () => (
  <div className="disclaimer">
    <div className="title">
      <FormattedMessage id="dashboard.respondents-disclaimer.title" defaultMessage="Disclaimer" />
    </div>
    <FormattedMessage
      id="dashboard.respondents-disclaimer.-paragraph"
      defaultMessage="It is your responsibility that all Internal Respondents have a long-term relationship with your organisation (e.g., is an employee or student), alternatively that you regularly obtain their individual consent to keeping and using their data."
    />
  </div>
);

export default Disclaimer;
